<template>
  <el-dialog
    title="导入学员"
    :visible="true"
    width="1000px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="
      () => {
        handleClose(fileList.length > 0)
      }
    "
  >
    <div class="students-import">
      <el-upload
        class="upload-demo"
        drag
        action=""
        :http-request="importAction"
        :show-file-list="false"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div class="import-buts">
        <el-button size="small" type="primary" @click="handleDown">
          下载学员导入模版
        </el-button>
        <el-button size="small" type="primary" @click="handleOpenError">
          查看导入异常日志
        </el-button>
      </div>
      <div class="success">
        <div v-for="(file, index) in fileList" :key="index">
          <div>{{ file }}</div>
          <div><span></span>100%</div>
        </div>
      </div>
      <div v-if="errorFlag">
        <el-table
          :data="errorList"
          style="width: 100%"
          :border="true"
          v-loading="loading"
          row-key="id"
        >
          <el-table-column
            v-for="(item, index) in errorColumn"
            :key="item.prop + index"
            :prop="item.prop"
            :label="item.label"
            align="center"
            :min-width="item.width || '100'"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                item.prop === 'type' && Number(scope.row[item.prop]) === 3
                  ? '导入学员'
                  : scope.row[item.prop]
              }}
            </template>
          </el-table-column>
        </el-table>
        <div class="import-pages">
          <el-pagination
            @size-change="handleLimitChange"
            @current-change="handlePageChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { downloadData } from '@/api/api'
import { baseURL } from '@/api/request'
import * as API from '../../api/students/index'
import { errorColumn } from './assets'
export default {
  name: 'ImportStudents',
  props: ['handleClose'],
  data() {
    return {
      fileList: [],
      errorFlag: false,
      limit: 10,
      page: 1,
      total: 0,
      errorList: [],
      loading: false,
      errorColumn
    }
  },
  methods: {
    async importAction(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('name', file.file.name)
      try {
        const res = await API.importStudents(formData)
        const { code } = res
        if (code === 0) {
          if (file.file?.name) this.fileList.push(file.file?.name)
        }
      } catch (error) {
      } finally {
        this.handleOpenError()
      }
    },
    handleDown() {
      downloadData(
        '/radioweb/adm/classStudent/exportStudent',
        {}
      )
    },
    handleOpenError() {
      this.errorFlag = true
      this.page = 1
      this.getErrorList()
    },
    async getErrorList() {
      const { page, limit } = this
      this.loading = true
      try {
        const params = { page, limit, type: 3 }
        const res = await API.getErrorList(params)
        const {
          code,
          data: { records = [], total }
        } = res
        if (code === 0) {
          this.errorList = records
          this.total = Number(total)
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    // 换每页条数
    handleLimitChange(limit) {
      this.limit = limit
      this.page = 1
      this.getErrorList()
    },
    // 换页
    handlePageChange(page) {
      this.page = page
      this.getErrorList()
    }
  }
}
</script>
<style lang="scss" scoped>
.students-import {
  text-align: center;
  .import-buts {
    margin: 20px auto;
  }
  .import-pages {
    margin: 20px 0 0;
  }
  .success {
    width: 90%;
    margin: 10px auto;
    margin-bottom: 20px;
    > div {
      text-align: left;
      padding-left: 20px;
      > div:first-child {
        color: rgba(16, 16, 16, 100);
        font-size: 14px;
        line-height: 24px;
      }
      > div:last-child {
        color: rgba(79, 204, 14, 100);
        font-size: 14px;
        > span {
          display: inline-block;
          width: 80%;
          margin-right: 20px;
          border-bottom: 2px solid rgba(27, 244, 55, 100);
        }
      }
    }
  }
}
</style>
